module.exports = __webpack_public_path__ + "media/images/incomplete-0eedf6e2f88a648e26e7ceecd3cc92b2.png";